// v2 TV-config context — scoped to the v2 display subtree. Exposes the
// per-patient field toggles (token / name / room / slot / booking mode) via
// useTVConfig().
//
// The config is passed in rather than fetched: it comes from the TV profile
// the staff picked, which the display screen already loads. Kept separate from
// v1's TVConfigurationContext so the migration stays self-contained.
import React, { createContext, useContext, ReactNode } from "react";
import { DEFAULT_TV_CONFIG, TVDisplayConfig } from "../api/tvConfig";

const TVConfigContext = createContext<TVDisplayConfig>(DEFAULT_TV_CONFIG);

export const TVConfigProvider = ({
  config,
  children,
}: {
  config?: TVDisplayConfig;
  children: ReactNode;
}) => (
  // Until the profile lands, defaults show everything rather than flashing a
  // board with missing columns.
  <TVConfigContext.Provider value={config ?? DEFAULT_TV_CONFIG}>
    {children}
  </TVConfigContext.Provider>
);

export const useTVConfig = () => useContext(TVConfigContext);
